export type IBreakPoint = {
  x: number;
  y: number;
}

export const BREAKPOINT_SMALL_PHONE: IBreakPoint = {
  x: 480,
  y: -1
}

export const BREAKPOINT_PHONE: IBreakPoint = {
  x: 768,
  y: -1
}

export const BREAKPOINT_TABLET: IBreakPoint = {
  x: 1164,
  y: 1366
}

export const BREAKPOINT_MEDIUM: IBreakPoint = {
  x: 1280,
  y: 1366
}

export const BREAKPOINT_LARGE: IBreakPoint = {
  x: 1536,
  y: 1366
}
